import { makeStyles } from 'tss-react/mui';

const DIALOG_WIDTH_PX = 660;

/**
 * Overrides `BDDialog` brings that the Figma modal does not: the grey
 * page-coloured content band, the white card floating inside it, and
 * the dialog width.
 *
 * The width needs a class because `dialogSize` only selects from MUI's
 * `maxWidth` scale, where the nearest stops are `sm` (600px) and `md`
 * (900px) — neither is the 660px drawn.
 */
const useStyles = makeStyles()((theme) => ({
  dialog: {
    '& .MuiDialog-paper': {
      maxWidth: DIALOG_WIDTH_PX,
    },
    '& .MuiDialogContent-root': {
      padding: theme.new.spacing.large,
      backgroundColor: theme.new.color.background.page,
    },
    // Undivided content drops its top padding when it follows the
    // title, so the band needs a rule that outweighs MUI's own. Matching
    // its adjacent-sibling selector is what tips the specificity.
    '& .MuiDialogTitle-root + .MuiDialogContent-root': {
      paddingTop: theme.new.spacing.large,
    },
  },
  card: {
    padding: theme.new.spacing.medium,
    borderRadius: theme.new.shape.borderRadius.small,
    backgroundColor: theme.new.color.common.white,
  },
  fieldLabel: {
    display: 'block',
    marginBottom: theme.new.spacing.small,
    color: theme.new.color.textPrimary,
  },
  // Present only to lock the field mid-send, so it drops the browser's
  // own border, padding, and min-content width.
  fieldset: {
    margin: 0,
    padding: 0,
    border: 0,
    minWidth: 0,
  },
  error: {
    marginTop: theme.new.spacing.small,
  },
  // With no buttons left, `ActionButtons` stretches custom content
  // across the footer, so the skeletons right-align themselves and
  // keep the gap the real buttons sit at.
  actionsSkeleton: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.new.spacing.medium,
  },
  actionSkeleton: {
    borderRadius: theme.new.shape.borderRadius.small,
  },
}));

export default useStyles;
